// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mcn-not-fount[data-v-063e59fa]{display:flex;align-items:center;justify-content:center;font-size:6em;height:100vh;background:#1c1d21;background-size:cover;padding:0;margin:0;position:relative;box-sizing:border-box;color:#5e5f6e}#mcn-not-fount h1[data-v-063e59fa]{font-size:4em;line-height:.9}#mcn-not-fount h2[data-v-063e59fa]{font-size:.8em}", ""]);
// Exports
module.exports = exports;
